<template>
  <div :class="collapse?'menu-bar-container-collapse':'menu-bar-container'">
    <div :class="collapse?'menu_bar2_collapse':'menu_bar2'">
      <!-- 导航菜单 -->
      <el-menu ref="navmenu" :default-active="$route.name" :class="collapse?'menu-bar-collapse-width':'menu-bar-width'"
               :collapse="collapse" :collapse-transition="false" :unique-opened="true"
               @open="handleopen" @close="handleclose" @select="handleselect"
               background-color=""
               text-color="#FFFFFF"
               active-text-color="#436EF3"
      >

        <!-- 导航菜单树组件，动态加载菜单 -->
        <menu-tree v-for="(item,index) in leftMenus" :index="'/'+item.url" :key="item.id" :menu="item"></menu-tree>
      </el-menu>
    </div>
    <div :class="collapse?'menu_bar3_collapse':'menu_bar3'"></div>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import MenuTree from "@/components/MenuTree"
import {initThemeData} from "@/utils/store"

let lastClick = 0;

let myApp;
export default {
  components: {
    MenuTree
  },

  props: {
    menuCode: {
      type: String,
      default: ""
    },
  },

  data() {
    return {
      theme: {},
      leftMenus: [],
      selectIndex: '/',
    }
  },
  mounted() {
    myApp = this;

    this.selectFirstMenu();
    this.theme = initThemeData(this.$store.state.app);
  },
  computed: {
    ...mapState({
      appName: state => state.app.appName,
      // themeColor: state=>state.app.themeColor,
      collapse: state => state.app.collapse,
      navTree: state => state.menu.navTree,
    }),
    mainTabs: {
      get() {
        return this.$store.state.tab.mainTabs
      },
      set(val) {
        this.$store.commit('updateMainTabs', val)
      }
    },
    mainTabsActiveName: {
      get() {
        return this.$store.state.tab.mainTabsActiveName
      },
      set(val) {
        this.$store.commit('updateMainTabsActiveName', val)
      }
    }
  },
  watch: {
    $route: 'selectFirstMenu',
    menuCode: {
      immediate: true,
      handler: function (val, oldVal) {
        // console.log("============ val = " + val + ",oldVal = " + oldVal);
        // if (this.menuCode !== oldVal) {
          setTimeout(function () {
            myApp.showSubMenus();
          }, 100);
        // }
      }
    },
  },
  methods: {
    showSubMenus: function () {
      this.leftMenus = this.$store.state.menu.navTree;
      let length = this.leftMenus.length;
      if (length > 0) {
        for (let i = 0; i < length; i++) {
          let url = this.leftMenus[i].url;
          if (url !== "") {

            if (!url.startsWith("/")) {
              url = "/" + url;
            }

            //默认选中第一个
            this.selectIndex = url;
            this.selectFirstMenu();

            //页面跳转
            // this.$router.push(url);
            break;
          }
        }
      }
    },
    handleopen() {
      // console.log('handleopen')
    },
    handleclose() {
      // console.log('handleclose')
    },
    handleselect(index) {
      // console.log('handleselect index = '+index);
      // console.log('handleselect menu = '+this.leftMenus[index]);
    },
    // 默认选中第一个菜单
    selectFirstMenu() {
      // console.log("this.selectIndex ---- " + this.$route.path);
      if (this.$refs.navmenu != null) {
        //
        //   console.log("this.selectIndex ---- "+this.selectIndex);
        //   this.$refs.navmenu.activeIndex = this.selectIndex;
        //   this.$forceUpdate();
        //
        //   console.log("this.$refs.navmenu.activeIndex ---- "+this.$refs.navmenu.activeIndex);
        this.$refs.navmenu.initOpenedMenu();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.menu-bar-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1020;
  overflow-x: hidden;
  overflow-y: auto;
  //background:linear-gradient(#4892F0, #1547A9);

  .el-menu {
    top: 0 !important;
    text-align: left;
    margin-top: -95px;
    width: 250px !important;
    border-right: none !important;
  }

  .el-menu-item {
    font-size: 16px !important;

    /**modify 首页菜单背景设置**/
    background: none !important;
  }

  .el-menu /deep/ .is-active.leftMenuItem1{
    /**modify 二级菜单选中文字颜色**/
    color: #436EF3 !important;

    background-image: url("/static/img/home/menu_selected2.png") !important;
    background-position: right !important;
    background-repeat: no-repeat !important;
    background-size: auto 100% !important;
    height: 85px !important;
    line-height: 85px;

    i{
      margin-top: 28px;
    }
    span{
      vertical-align: -15px;
    }
  }

  .menu-bar-width {
    top: 195px;
    width: 250px;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .menu-bar-collapse-width {
    top: 95px;
  }
}

.el-menu /deep/ .leftMenuItem1 {
  padding-left: 50px !important;

  /**modify 二级菜单背景设置**/
  background: none !important;
}

.el-menu /deep/ .leftMenuItem2 {
  margin-left: 0 !important;
  background-color: #203140 !important;
  color: #AFB8C4 !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 15px !important;;
}

.el-menu /deep/ .leftMenuItem2:hover {
  margin-left: 0 !important;
  //background-color: #1A2835 !important;
  color: #436EF3 !important;
}

.el-menu /deep/ .leftMenuItem21 {
  /*margin-left: 20px !important;*/
  .el-submenu__title i {
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
  }
}

.el-menu /deep/ .leftMenuItem21 .el-submenu__title {
  font-size: 15px !important;;
  padding-left: 40px !important;
  //background-color: rgba(41, 61, 81, 0.6) !important;
}

.el-menu /deep/ .leftMenuItem21 {
  padding-left: 0 !important;
  //background-color: rgba(41, 61, 81, 0.6) !important;
}

.el-menu /deep/ .leftMenuItem3 {
  padding-left: 70px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.el-menu /deep/ .leftMenuItem3:hover {
  //background-color: #1A2835 !important;
  //color: #00D0CF !important;
}

.el-menu /deep/ .leftMenuItem4 {
  padding-left: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.el-menu /deep/ .leftMenuItem5 {
  padding-left: 50px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.el-menu /deep/ .el-submenu__title {
  /*padding-left: 0 !important;*/

  /**modify 一级菜单背景设置**/
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/NavBar.vue